import { createColumn, defaultColumns, inputTextField, relationField, numberSort } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Name',
    field: 'name',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Description',
    field: 'description',
    component: inputTextField({ req: false })
  }),
  createColumn({
    label: 'Account Number',
    field: 'accountNumber',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Quickbooks Customer ID',
    field: 'qbCustomerId',
    type: 'number',
    sort: numberSort,
    component: inputTextField({ req: false, type: 'number' })
  }),
  createColumn({
    label: 'Sort Code',
    field: 'sortCode',
    component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'Fund Account Type',
    field: 'fundAccountType',
    ...relationField({
      props: { addButton: false, allowEdit: false },
      validation: { required: true },
      type: 'one',
      localKey: 'fundAccountTypeId',
      // localKey: 'id',
      // fk: 'fundAccountTypeId',
      namespace: 'fundAccountType',
      filterIs: 'text-filter'
      // label: 'description'
    })
  })
].concat(defaultColumns)
